<template>
  <BaseButton primary @click="openNewSmsCampaignDialog"> New SMS Campaign </BaseButton>
</template>

<script>
import { accountSmsCampaignsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      default: null,
    },
  },
  methods: {
    submit(data) {
      return accountSmsCampaignsClient.store(this.accountId, data);
    },
    openNewSmsCampaignDialog() {
      this.$modal.show({
        component: () =>
          import('@/components/SmsCampaign/CreateSmsCampaignDialog/CreateSmsCampaignDialog.vue'),
        props: {
          accountId: this.accountId,
          defaultData: {
            filter: {
              //
            },
          },
          action: this.submit,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
